import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';

export default function CheckboxInput({
  label,
  name,
  value,
  onChange,
  required,
  error,
  disabled,
  helperText
}) {
  const handleChange = (e) => {
    onChange({ target: { name, value: e.target.checked } });
  };

  return (
    <FormControl error={error} component="fieldset">
      <FormControlLabel
        disabled={disabled}
        control={
          <Checkbox
            checked={value || false}
            onChange={handleChange}
            name={name}
            sx={{ padding: 0, marginX: '9px' }}
          />
        }
        label={label}
        className={`form-label ${required ? ' required' : ''}`}
      />
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
}
